import { Badge } from 'components/badge';
import { calculateChange } from 'utils/cart';
import { BadgeColor, BadgePadding } from 'types';
import { getCartAmounts, isCartOrCheckout } from 'utils/helpers';

import { Result, TotalCartProps } from './types';

export const getTotalCardData = ({
  tip,
  data,
  balance,
  shippingPrice,
  paymentMethods,
  companyProcessingFees,
  isProcessingFeeEnabled,
}: Omit<TotalCartProps, 'children'>) => {
  const { tax, saleTotal, totalAmount, processingFees } = getCartAmounts({
    tip,
    data,
    shippingPrice,
    paymentMethods,
    isProcessingFeeEnabled,
  });

  const isFreeShipping = isCartOrCheckout(data)
    ? data?.shipping?.isFreeShipping
    : data?.isFreeShipping;

  const result: Result[] = [
    { title: 'Sub Total', value: totalAmount },
    { value: tax, title: `Tax (${data?.event?.tax ?? 0}%)` },
  ];

  if (typeof tip === 'number') {
    result.push({
      value: tip,
      title: 'Tip',
    });
  }

  if (isProcessingFeeEnabled) {
    result.push({
      value: +processingFees,
      title: `Processing Fees (${companyProcessingFees}%)`,
    });
  }

  if (Number(shippingPrice) > 0) {
    result.push({
      title: 'Shipping',
      value: isFreeShipping ? 0 : shippingPrice,
      subtitle: isFreeShipping ? (
        <Badge
          text="Free"
          styleType={BadgeColor.Blue}
          padding={BadgePadding.Small}
        />
      ) : undefined,
    });
  }

  result.push({ value: saleTotal, title: 'Sale Total' });

  if (typeof balance === 'number') {
    result.push({ value: balance, title: 'Balance Due' });
  }

  const changeAmount = calculateChange(paymentMethods);
  if (changeAmount > 0) {
    result.push({ title: 'Change', value: changeAmount });
  }

  return result;
};
